<app-course-catalogue-details-card id="schedule" i18n-label label="Schedule">
  <p>
    {{ text() }}
  </p>
  <ul class="list-inside">
    @for (dayText of listSchedule(); track $index) {
      <li class="ml-4">{{ dayText }}</li>
    }
  </ul>
</app-course-catalogue-details-card>
